import { RouteConfig } from '@dfl/react-security';
import { lazy } from 'react';
import InvitationApp from './InvitationApp';
import { EmailVerify } from 'modules/authentication/pages';

const loadMainApp = () => import('routes/MainApp');
export const MainApp = lazy(loadMainApp);

const loadAuthApp = () => import('routes/AuthApp');
export const AuthApp = lazy(loadAuthApp);

const loadDriver = () => import('routes/Driver');
export const DriverApp = lazy(loadDriver);

export const routes: RouteConfig = {
  Driver: {
    path: '/driver/*',
    component: DriverApp,
  },
  Auth: {
    path: '/auth/*',
    onlyAnonymous: true,
    component: AuthApp,
  },
  /* MapLayout: {
    path: '/map/*',
    authenticated: true,
    redirect: '/auth/login',
    component: MapApp,
  }, */
  MainLayout: {
    path: '*',
    authenticated: true,
    redirect: '/auth/login',
    component: MainApp,
  },
  InvitationLayout: {
    path: '/invitation/accept/:key',
    component: InvitationApp,
  },
  DriverVerify: {
    path: '/auth/email-verify/:key',
    component: EmailVerify,
  },
};
